import React from 'react';
import styled from 'styles/styled';

import {
  PolygonGlyph,
  SolanaGlyph,
} from 'components/CreatingTournament/ChainSelector/ChainGlyphs';

export interface NetworkChipProps {
  chain: 'polygon' | 'solana';
}

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px 6px 8px;
  background: #292B2E;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: #EFEFEF;
  letter-spacing: 0.02em;
`;

const Glyph = styled.span`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  svg {
    width: 13px;
    height: 13px;
  }
`;

const Name = styled.span`
  font-weight: 700;
  letter-spacing: 0.04em;
`;

const Sub = styled.span`
  color: #7A7E8C;
  font-weight: 300;
  margin-left: 2px;
`;

const NetworkChip: React.FC<NetworkChipProps> = ({ chain }) => {
  const Logo = chain === 'solana' ? SolanaGlyph : PolygonGlyph;
  const name = chain === 'solana' ? 'SOL' : 'POL';
  const network = chain === 'solana' ? 'Solana' : 'Polygon';
  return (
    <Chip aria-label={`${network} network`}>
      <Glyph aria-hidden="true">
        <Logo size={22} />
      </Glyph>
      <Name>{name}</Name>
      <Sub>{network}</Sub>
    </Chip>
  );
};

export default NetworkChip;
